import { Paginated, Report, Loadable, idle, LoadableStatus } from '@card/types';
import { ReportsAction, ReportsActionType } from './actions';

export interface ReportsState {
  reports: Loadable<Paginated<Report>>;
}

const INITIAL_STATE: ReportsState = {
  reports: idle()
};

export function reportsReducer(state = INITIAL_STATE, action: ReportsAction): ReportsState {
  switch (action.type) {
    case ReportsActionType.FetchReportsStarted:
      return { ...state, reports: { ...state.reports, status: LoadableStatus.Fetching } };
    case ReportsActionType.FetchReportsSuccess:
      return { ...state, reports: { data: action.payload, status: LoadableStatus.Fetched } };
    case ReportsActionType.FetchReportsError:
      return {
        ...state,
        reports: { ...state.reports, error: action.payload, status: LoadableStatus.Error }
      };
    default:
      return state;
  }
}
